module.exports = __webpack_public_path__ + "img/right_2.969a3d98.jpg";